import * as React from "react";
import { stylesheet } from "typestyle";

const css = stylesheet({
  container: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 48,
    width: 40,
  },
  annotationIcon: {
    position: "absolute",
    bottom: 8,
    right: 4,
    width: 16,
    height: 16,
    // the only way to make sub icon be on top of the map
    zIndex: 1000,
  },
});

interface IProps {
  icon: React.ReactNode;
  annotationIcon?: React.ReactNode;
}

export const AnnotatableIconContainer: React.FC<IProps> = ({
  icon,
  annotationIcon,
}) => {
  return (
    <div className={css.container}>
      {icon}
      {annotationIcon && (
        <div className={css.annotationIcon}>{annotationIcon}</div>
      )}
    </div>
  );
};
